var Component = require("!../node_modules/.store/vue-loader@12.1.0/node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../node_modules/.store/vue-loader@12.1.0/node_modules/vue-loader/lib/selector?type=script&index=0!./App.vue"),
  /* template */
  require("!!../node_modules/.store/vue-loader@12.1.0/node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-3d6d4c48\"}!../node_modules/.store/vue-loader@12.1.0/node_modules/vue-loader/lib/selector?type=template&index=0!./App.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/App.vue
// module id = 912
// module chunks = 76